// extracted by mini-css-extract-plugin
export default {"main":"SupportDirectoryPage_main__c4HKs","heading":"SupportDirectoryPage_heading__P7j7o","tiles_container":"SupportDirectoryPage_tiles_container__n+ySz"};